/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["validator", "validationOpts"];
import { Component } from 'react';
import * as validators from './constants/validators';
import makeValidationResponse from './utils/makeValidationResponse';
import isThenable from 'hs-promise-utils/isThenable';
import { jsx as _jsx } from "react/jsx-runtime";
export const validatorsList = Object.keys(validators);
export default (WrappedComponent => {
  var _class;
  return _class = class extends Component {
    constructor(...args) {
      super(...args);
      this.state = {
        error: this.props.error || false,
        empty: false,
        isValidating: false,
        pristine: !this.props.error
      };
      this.getValidatorFunction = () => {
        const {
          validator
        } = this.props;
        if (typeof validator === 'function') return validator;
        return validators[validator];
      };
      this.setValid = input => {
        const {
          onSuccess
        } = this.props;
        this.setState({
          error: false,
          empty: false,
          isValidating: false,
          pristine: false
        });
        if (onSuccess) {
          onSuccess(input);
        }
      };
      this.setInvalid = input => {
        const {
          onError
        } = this.props;
        this.setState({
          error: true,
          empty: false,
          isValidating: false,
          pristine: false
        });
        if (onError) {
          onError(input);
        }
      };
      this.setValidating = () => {
        this.setState({
          empty: false,
          isValidating: true,
          pristine: false
        });
      };
      this.setEmpty = () => {
        this.setState({
          empty: true,
          isValidating: false,
          pristine: false
        });
      };
      this.validateInput = input => {
        const {
          validationOpts
        } = this.props;
        return this.getValidatorFunction()(input, validationOpts);
      };
      this.handleValidation = evt => {
        const {
          target: {
            value
          }
        } = evt;
        if (!value) {
          this.setEmpty();
        } else {
          const validationStatus = this.validateInput(value);
          const setValidationState = ({
            input,
            isValid
          }) => {
            if (isValid) {
              this.setValid(input);
            } else {
              this.setInvalid(input);
            }
          };

          // validationStatus will be a promise if the
          // validator function performs async operations.
          if (isThenable(validationStatus)) {
            validationStatus.then(result => {
              // Checks if the input changed from
              // when async validation began.
              if (result.input === value) {
                setValidationState(result);
              }
            });
            this.setValidating();
          } else {
            setValidationState(makeValidationResponse(value, validationStatus));
          }
        }
      };
    }
    render() {
      const {
        error,
        empty,
        isValidating,
        pristine
      } = this.state;
      const _this$props = this.props,
        rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, rest, {
        error: error,
        empty: empty,
        isValidating: isValidating,
        pristine: pristine,
        validateInput: this.handleValidation
      }));
    }
  }, _class.defaultProps = {
    validationOpts: {}
  }, _class;
});

/**
 * @typedef {Object} UIValidatorProps
 * @property {function} [onError]
 * @property {function} [onSuccess]
 * @property {string|function} validator - one of validatorsList or a custom function
 * @property {Object} [validationOpts]
 * @property {boolean} [error]
 */